<template>
  <component :is="tag" class="home-content">
    <div
      v-for="component in blok.body"
      :key="component._uid"
      class="section-inner"
    >
      <StoryblokComponent :blok="component" />
    </div>
  </component>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});
</script>

<style lang="scss" scoped>
.home-content {
  row-gap: 4rem;
  @include for-desktop-up {
    row-gap: 6.25rem;
  }
  .section-inner {
    --margin-col-span: 1;

    @include for-desktop-up {
      --margin-col-span: 3;
      grid-column: calc(var(--margin-col-span) + 1) /
        calc(-1 * var(--margin-col-span) - 1);
    }
  }
}
</style>
